import type { BaseFieldStore } from '../Stores/BaseFieldStore'
import { FieldType } from '../Stores/Types/FieldTypeEnum'
import { BaseFieldInputStrategy } from './BaseFieldInputStrategy'

/**
 * Стратегія для color полів
 */
export class ColorFieldStrategy extends BaseFieldInputStrategy {
    fieldType: FieldType = FieldType.COLOR

    extractValue(event: any, field: BaseFieldStore): any {
        const value = super.extractValue(event, field)

        // Якщо color picker повертає об'єкт з методом toHexString
        if (typeof value === 'object' && value && typeof value.toHexString === 'function') {
            return value.toHexString()
        }

        return value
    }
}
